/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var vCardParser: any;
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ContactMultipleDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return ContactMultipleForm.formKey; }

        protected form = new ContactMultipleForm(this.idPrefix);
        public saveCallback: (response: string) => void;

        constructor() {
            super();
            this.form.ListEl.element.find(".el-list").html(``);
        }

        downloadToFile(content: string, filename: string, contentType: string) {
            const a = document.createElement('a');
            const file = new Blob([content], { type: contentType });

            a.href = URL.createObjectURL(file);
            a.download = filename;
            a.click();

            URL.revokeObjectURL(a.href);
        }

        strToVcf(input: string) {
            var Re1 = /^(version|fn|title|org):(.+)$/i;
            var Re2 = /^([^:;]+);([^:]+):(.+)$/;
            var ReKey = /item\d{1,2}\./;
            var fields = {} as any;

            input.split(/\r\n|\r|\n/).forEach(function (line) {
                var results, key;

                if (Re1.test(line)) {
                    results = line.match(Re1);
                    key = results[1].toLowerCase();
                    fields[key] = results[2];
                } else if (Re2.test(line)) {
                    results = line.match(Re2);
                    key = results[1].replace(ReKey, '').toLowerCase();

                    var meta = {};
                    results[2].split(';')
                        .map(function (p, i) {
                            var match = p.match(/([a-z]+)=(.*)/i);
                            if (match) {
                                return [match[1], match[2]];
                            } else {
                                return ["TYPE" + (i === 0 ? "" : i), p];
                            }
                        })
                        .forEach(function (p) {
                            meta[p[0]] = p[1];
                        });

                    if (!fields[key]) fields[key] = [];

                    fields[key].push({
                        meta: meta,
                        value: results[3].split(';')
                    })
                }
            });

            return fields;
        }

        addContact(obj: any) {
            var dataKontak = this.strToVcf(obj.vcard);
            var $this = this;
            var el = $(`<div class="row p-2">
                            <div style="width: 50px;"><i class="fa fa-user" style="font-size: 38px;margin-top: 2px;"></i></div>
                            <div class="col pl-1 pr-4" style="margin:auto;">
                                <div class="text text-bold ">${dataKontak.fn}</div>
                                <div class="text" style="display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">${dataKontak.tel[0].value[0]}</div>
                            </div>
                            <div style="width: 45px;" class="pl-0 DownloadVcardDialog" data-vcard-name="${obj.displayName}" data-vcard="${obj.vcard}" title="Download vcard"><i class="fa fa-download mt-1" style="font-size: 25px;cursor: pointer;"></i></div>
                        </div>`);
            this.form.ListEl.element.find(".el-list").append(el);
            //download 1 kontak menjadi vcard
            $(".DownloadVcardDialog").unbind("click");
            $(".DownloadVcardDialog").on("click", function () {
                var strKontak = $(this).attr("data-vcard");
                var namaKontak = $(this).attr("data-vcard-name");
                $this.downloadToFile(strKontak, namaKontak + '.vcf', 'text/vcard');
            })
        }

        getToolbarButtons() {
            return [];
        }

        showFromInbox(arr: string) {
            var list = JSON.parse(arr);
            list.forEach((x, i) => {
                this.addContact(x);
            })
        }

        updateTitle() {
            this.dialogTitle = "List Contact";
        }
    }
}